module.exports = __webpack_public_path__ + "img/Path 25 Copy@3x.1025ee7f.png";